import { Chat } from "@/types";

import { axios } from "../axios.instance";

export type UnmuteChatRequest = {
  chatId: string;
};

export type UnmuteChatResponse = Chat;

export const unmuteChat = async (body: UnmuteChatRequest): Promise<UnmuteChatResponse> => {
  const { data } = await axios.post(`/chats/${body.chatId}/unmute`);

  return data;
};
